import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { useState } from "react";
import useMedia, { MediaSizes } from "../../hooks/useMedia";

/**
 * Tooltip component.
 *
 * Style sub-elements via Tailwind's `[&_.class-name]:property` syntax on `className`:
 * - `tooltip-trigger` — wrapper around children (default: `m-2`)
 * - `tooltip-content` — the tooltip bubble (default: `bg-gray-700 text-white min-w-max rounded-md p-2 text-sm`)
 * - `tooltip-arrow` — the directional arrow (default: `border-b-gray-700` or `border-t-gray-700`)
 *
 * @example
 * <Tooltip
 *   tooltipText="Hello"
 *   className="cursor-pointer [&_.tooltip-content]:bg-blue-600 [&_.tooltip-content]:rounded-md [&_.tooltip-content]:px-3 [&_.tooltip-content]:py-2"
 * >
 *   <button>Hover me</button>
 * </Tooltip>
 */
export default function Tooltip(props) {
  var children = props.children,
    className = props.className,
    tooltipText = props.tooltipText,
    tooltipClass = props.tooltipClass,
    position = props.position,
    verticalPosition = props.verticalPosition,
    onMouseEnter_ = props.onMouseEnter,
    onMouseLeave_ = props.onMouseLeave,
    onClick_ = props.onClick,
    disabled = props.disabled;
  var _useState = useState(false),
    isHovered = _useState[0],
    setIsHovered = _useState[1];
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, {
      relative: !(className !== null && className !== void 0 && className.includes("absolute")) && !(className !== null && className !== void 0 && className.includes("fixed")) && !(className !== null && className !== void 0 && className.includes("static")) && !(className !== null && className !== void 0 && className.includes("relative"))
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltip-trigger m-2",
    onMouseEnter: function onMouseEnter() {
      if (typeof onMouseEnter_ === "function") onMouseEnter_();
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      if (typeof onMouseLeave_ === "function") onMouseLeave_();
      setIsHovered(false);
    },
    onClick: function onClick() {
      if (typeof onClick_ === "function") onClick_();
    }
  }, children), isHovered && !isMobile && !disabled && /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col absolute z-[9999]", {
      "top-0 translate-y-[-100%]": verticalPosition === "top",
      "left-0": position === "left",
      "right-0": position === "right"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("tooltip-arrow w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent", {
      "order-1 border-b-[5px] border-b-gray-700": verticalPosition === "bottom",
      "order-2 border-t-[5px] border-t-gray-700": verticalPosition === "top",
      "mr-auto ml-4": position === "left",
      "ml-auto mr-4": position === "right"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("tooltip-content min-w-max rounded-md p-2 text-sm text-white bg-gray-700", {
      "order-2": verticalPosition === "bottom",
      "order-1": verticalPosition === "top"
    }, tooltipClass)
  }, tooltipText)));
}